import { useState } from 'react';
import { StyledMediaAssetProps } from '../../Container/styles';
import { StandardImageStyled } from './styles';
import { DefaultMediaAssetProps } from './use-media-asset-props';

export interface StandardImageProps {
  generalProps: DefaultMediaAssetProps;
  assetProps: StyledMediaAssetProps;
}

const StandardImage: React.FC<StandardImageProps> = ({
  generalProps,
  assetProps,
}) => {
  const {
    fallback = 'https://images.ctfassets.net/uqnk3k6tiu47/yNnmq3QdK9QayVnVQ401X/a18c2a2766d8063e91fbd62640cdcd87/logo-compact-large.jpg',
  } = generalProps;
  const [imgSrc, setImgSrc] = useState(generalProps.path || fallback);
  const handleError = () => setImgSrc(fallback);

  return (
    <StandardImageStyled
      {...assetProps}
      className={`standard-image ${!!generalProps.className ? generalProps.className : ''}`}
      src={imgSrc}
      alt={`${generalProps.alt}`}
      loading={generalProps.loading}
      onClick={generalProps.onClick}
      onError={handleError}
      style={{ objectFit: generalProps.objectFit }}
    />
  );
};

export default StandardImage;
